import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CurrentUserService } from '../services/current-user.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonuploadimagemodelComponent } from '../pages/shared/commonuploadimagemodel/commonuploadimagemodel.component';
import { AuthServices } from '../services/auth.service';
import { serviceurl } from '../constant/constant';
import { ToastService } from '../services/toast.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['../pages/auth/auth-form.scss', './user-profile.component.scss'],
    standalone: false
})
export class UserProfileComponent implements OnInit {
  user: any = {};
  selectedImage: any;
  userForm: FormGroup;
  isLoading: boolean = false;

  constructor(
    private currentUserService: CurrentUserService,
    private formBuilder: FormBuilder,
    private ngModel: NgbModal,
    private location: Location,
    private userService: AuthServices,
    private router: Router,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.userForm = this.formBuilder.group({
      image: [this.selectedImage],
      display_name: [this.user?.display_name || '', Validators.required],
      first_name: [this.user?.first_name || '', Validators.required],
      last_name: [this.user?.last_name || ''],
      email: [{ value: this.user?.email || '', disabled: true }],
    });

    this.currentUserService.currentUser.subscribe((data) => {
      if (data !== null) {
        this.user = data;
        if (this.user.image) {
          this.selectedImage = serviceurl + this.user.image;
        }
        this.userForm.patchValue({
          image: this.selectedImage,
          display_name: this.user.display_name,
          first_name: this.user.first_name,
          last_name: this.user.last_name,
        });
        this.cdr.detectChanges();

        // Securely fetch private account details (including email) on-demand in-memory
        if (this.user.id) {
          this.userService.getAccountDetails(this.user.id).subscribe({
            next: (account: any) => {
              if (account?.email) {
                this.userForm.get('email')?.setValue(account.email);
                this.cdr.detectChanges();
              }
            },
            error: (err) => {
              console.warn('Could not fetch account details:', err);
            
          this.cdr.detectChanges();}
          });
        }
      }
    });
  }

  userSubmit() {
    this.isLoading = true;
    const obj = {
      first_name: this.userForm.value.first_name,
      last_name: this.userForm.value.last_name,
      email: this.userForm.value.email,
      display_name: this.userForm.value.display_name,
    };
    this.userService.userUpdateData({ ...obj }, Number(this.user.id)).subscribe(
      (data: any) => {
        if (data) {
          const user = localStorage.getItem('currentUser')
            ? JSON.parse(localStorage.getItem('currentUser'))
            : null;

          user.first_name = data.first_name;
          user.last_name = data.last_name;
          user.display_name = data.display_name;
          this.isLoading = false;
          const { stripe_customer_id: _s1, email: _e1, ...safeUser1 } = user;
          localStorage.setItem('currentUser', JSON.stringify(safeUser1));
          this.currentUserService.setUserData(safeUser1);
          this.toastService.showSuccess('Profile saved.', 'success');
          this.location.back();
        }
      
          this.cdr.detectChanges();},
      (error) => {
        this.isLoading = false;
      
          this.cdr.detectChanges();}
    );
  }

  handleFileInput(): void {
    const modalRef = this.ngModel.open(CommonuploadimagemodelComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
    });

    modalRef.componentInstance.selectedImage = this.selectedImage;
    modalRef.result.then((resModal) => {
      // Closed or cancelled: nothing changed (this used to save the whole
      // account as the picture, showing a broken image).
      if (!resModal?.image_path) return;
      const user = localStorage.getItem('currentUser')
        ? JSON.parse(localStorage.getItem('currentUser'))
        : null;


      this.userService.currentUserData(user.id).subscribe((res: any) => {
        user.image = res.image ? res.image : res;

        const { stripe_customer_id: _s2, email: _e2, ...safeUser2 } = user;
        localStorage.setItem('currentUser', JSON.stringify(safeUser2));
        this.currentUserService.setUserData(safeUser2);
        this.userForm
          .get('image')
          .setValue(resModal?.image_path ? resModal.image_path : res);
        if (resModal?.image_path) {
          this.selectedImage = serviceurl + resModal.image_path;
        } else {
          this.selectedImage = res?.image ? serviceurl + res?.image : res;
        }
        this.userForm.updateValueAndValidity();
      
          this.cdr.detectChanges();});
    
          this.cdr.detectChanges();});
  }

  goBack(): void {
    this.location.back();
  }
}
